import { CaretDownSvg } from '@/assets/icons';
import { StyledCollapse } from './styles';

const CollapsePanel = ({ icon, title, footer, children, ...props }) => {
  return (
    <StyledCollapse
      {...props}
      defaultActiveKey="1"
      items={[
        {
          key: '1',
          label: (
            <>
              {icon}
              {title}
            </>
          ),
          children,
        },
      ]}
      expandIcon={({ isActive }) => (
        <CaretDownSvg style={{ fontSize: 14, transform: `rotate(${isActive ? 0 : 180}deg)` }} />
      )}
      expandIconPosition="end"
    />
  );
};

export default CollapsePanel;
